import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { LabelInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { Toggle } from './Toggle'

export interface FormValues
  extends Omit<Partial<LabelInput>, 'useForProductRecommendations'> {
  useForProductRecommendations: boolean
}

export const LabelForm: FC<FormProps<FormValues>> = flowMax(
  addDisplayName('ProductFeatureForm'),
  addTranslationHelpers,
  ({ values, onChange, t }) => (
    <div>
      <Toggle
        id="useForProductRecommendations"
        label={t('admin.resources.labels.fields.useForProductRecommendations')}
        value={values.useForProductRecommendations}
        onChange={(useForProductRecommendations) =>
          onChange({ ...values, useForProductRecommendations })
        }
      />
    </div>
  )
)
